<template>
    <div>
        <div class="side-bar right-bar nicescroll" :class="{ 'right-bar-enabled': open }">
            <h4 class="text-center">
                <button type="button" class="btn btn-inverse btn-rounded pmlFormatCurrencyByIdwaves-light over_hide" @click.prevent="refresh()">
                    {{ $t('online_users') }}
                    <span class="btn-label btn-label-right"><i class="fa fa-refresh" :class="isSpinning()"></i></span>
                </button>
            </h4>
            <div class="p_0_10 m_b_10">
                <input v-model="search" class="form-control" :placeholder="`${$t('type_to_find')}...`" />
            </div>
            <div class="contact-list nicescroll">
                <ul class="list-group contacts-list">
                    <li class="list-group-item" v-for="(item, index) in ordered">
                        <div class="pull-left m-r-5">
                            <span class="initial_name">{{ item.name_initials }}</span>
                        </div>
                        <i class="fa fa-circle" :class="getClass(item)"></i>
                        <span class="name t_overflow">{{ item.first_name }} {{ item.last_name }}</span>
                        <small class="text-center" v-if="item.last_request">{{ item.last_request | pmlHumanDate }}</small>
                        <small class="text-center" v-else>{{ $t('never_seen') }}</small>
                    </li>
                </ul>
            </div>
        </div>
        <div @click.prevent="close()" class="fade_users" v-if="open"></div>
    </div>
</template>

<style scoped>
    .fade_users {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background-color: transparent;
        height: 100%;
        z-index: 98;
    }
</style>

<script>
    import moment from 'moment'
    import { refreshMembers } from 'services/company'
    import { mapGetters } from 'vuex'
    import { orderBy, filter, isEmpty } from 'lodash'
    import { sanitizeAndLower } from 'utils/helpers/strings'

    export default {
        name: 'UsersTracking',
        props: [ 'open' ],
        data () {
            return {
                isLoading: false,
                search: ''
            }
        },
        computed: {
            ...mapGetters({
                'members': 'getActiveMembers'
            }),
            seen () {
                let list = filter(this.members(), (obj) => {
                    return obj.last_request !== null
                })
                return orderBy(list, ['last_request', 'full_name'], ['desc', 'asc']) || []
            },
            neverSeen () {
                let list = filter(this.members(), (obj) => {
                    return obj.last_request === null
                })
                return orderBy(list, ['last_request', 'full_name'], ['desc', 'asc']) || []
            },
            ordered () {
                const search = sanitizeAndLower(this.search)
                const list = this.seen.concat(this.neverSeen)
                return isEmpty(search) ? list : filter(list, response => sanitizeAndLower(response['full_name']).indexOf(search) >= 0)
            }
        },
        methods: {
            close () {
                this.$emit('close')
            },
            refresh () {
                this.isLoading = true
                refreshMembers()
                    .then(() => { this.isLoading = false })
            },
            getClass (item) {
                let lastRequest = moment(this.$options.filters.pmlDate(item.last_request, 'YYYY-MM-DD HH:mm:ss'))
                let diff = moment().diff(lastRequest, 'minutes')

                if (diff <= 5) return 'online'
                if (diff > 5 && diff <= 30) return 'away'
                else return 'offline'
            },
            isSpinning () {
                return this.isLoading ? 'fa-spin' : ''
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/root/header/UsersTracking.vue